import {
    Box,
    Button,
    ButtonProps,
    Dialog,
    DialogContent
} from '@mui/material'
import CloseIcon from '../../../assets/home-dialog/close.png'
import { Image, Carousel } from 'antd'
import { CustomHTML } from '../../../components/ui/CustomHTML'
import { ROOT_PATH } from '../../../common/config'
import styled from 'styled-components'

const StyledUser = styled.div`
  h1 {
    font-weight: 700;
    font-size: 22px !important;
  }
`

export type SMAppHomeDialogProps = {
    open?: boolean
    onClose?: () => void
    onAction?: () => void
    cancelButtonProps?: ButtonProps
    adData?: Object
}

export const SMAppHomeDialog: React.FC<SMAppHomeDialogProps> = (props) => {
    // ======================= PROPS
    const {
        open = false,
        onClose,
        onAction,
        adData = null
    } = props

    const detail = (id: number) => {
        onAction()
        window.location.href = (ROOT_PATH + '/ad-detail?id=' + id)
    }

    // ======================= VIEWS
    return (
        <Dialog open={open} onClose={onClose} maxWidth={false}>
            <DialogContent
                sx={{
                    padding: 0,
                    paddingTop: 0,
                }}
            >
                {adData !== null && adData.length > 0 ?
                    (<Box>
                        <Box sx={{
                            width: '100%',
                            minHeight: '64px',
                            backgroundColor: '#FFFFFF'
                        }}>
                            <Carousel autoplay={true}>
                                {adData.map((item, index) => (
                                    <Box key={index} sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignContent: 'center',
                                        alignItems: 'center',
                                    }}>

                                        <Box sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignContent: 'end',
                                            justifyContent: 'end',
                                            alignItems: 'end'
                                        }}>
                                            <Button
                                                onClick={onClose}
                                                sx={{
                                                    height: '64px',
                                                    width: '64px',
                                                }}
                                            >
                                                <Image src={CloseIcon} width={24} height={24} alt='' preview={false}></Image>
                                            </Button>
                                        </Box>

                                        <div className="App" style={{
                                            paddingLeft: '10px',
                                            paddingRight: '10px',
                                        }}>
                                            <StyledUser>
                                                <CustomHTML htmlContent={'<div id="preview" class="ck-content">' + adData[index]['attributes']['content'] + '</div>'} />
                                            </StyledUser>
                                        </div>

                                        <Box sx={{
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignContent: 'center',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            paddingTop: '30px',
                                            paddingBottom: '30px'
                                        }}>
                                            <Button
                                                onClick={() => detail(adData[index]['id'])}
                                                sx={{
                                                    borderRadius: '30px',
                                                    height: '60px',
                                                    paddingLeft: '60px',
                                                    paddingRight: '60px',
                                                    bgcolor: '#FFC107',
                                                    border: '1px solid #FFC107',
                                                    color: '#141F39',
                                                    '&:hover': {
                                                        bgcolor: '#FFC107',
                                                    },
                                                    textTransform: 'none'
                                                }}
                                            >
                                                View Detail
                                            </Button>
                                        </Box>
                                    </Box>
                                ))}
                            </Carousel>
                        </Box>

                    </Box>)
                    :
                    (<Box></Box>)}
            </DialogContent>
        </Dialog>
    )
}

// ======================= EXPORT
export default SMAppHomeDialog
